import { render, staticRenderFns } from "./DuplicateProjectWizard.vue?vue&type=template&id=5149f7f8&"
import script from "./DuplicateProjectWizard.vue?vue&type=script&lang=js&"
export * from "./DuplicateProjectWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports